import * as yup from 'yup';

export const ideaValidationSchema = yup.object().shape({
    problem: yup.string().required().max(2000),
    currentSituation: yup.string().required().max(2000),
    suggestedSolution: yup.string().required().max(2000),
})